import { FEATURE_FLAGS } from '../../../featureFlags';
import ClustersList from './ClustersList.vue';
import ClusterDetails from './ClusterDetails.vue';

const commonMeta = {
  featureFlag: FEATURE_FLAGS.CLUSTERS,
  permissions: ['administrator', 'agent'],
};

export const routes = [
  {
    path: 'clusters',
    name: 'clusters_list',
    component: ClustersList,
    meta: commonMeta,
  },
  {
    path: 'clusters/:clusterId(\\d+)',
    name: 'cluster_details',
    component: ClusterDetails,
    meta: commonMeta,
    props: route => ({ clusterId: route.params.clusterId }),
  },
];

export default routes;
